module.exports = __webpack_public_path__ + "3b36bf9046e07cd1e74dc1c5f855c05f.MP3";